import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { Collaborators } from '../get-collaborators/types.tsx';
import type { CrossJoinTargetProduct } from '../../common/types.tsx';

const URL = '/gateway/api/growth/cross-join-nudges-confluence/get-permitted-confluence-users';

type AccountIds = string[];

export const getConfluenceUsers = async (
	collaborators: Collaborators,
	cloudId: string,
): Promise<Collaborators> => {
	try {
		if (!collaborators || collaborators.length === 0) {
			return [];
		}
		const accountIds = collaborators.map((c) => c.id);
		const confluenceUsers = await fetchJson<AccountIds>(URL, {
			method: 'POST',
			body: JSON.stringify({ cloudId, accountIds }),
		});

		return collaborators.filter((c) => confluenceUsers.includes(c.id));
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			meta: {
				id: 'getConfluenceUsers',
				packageName: 'jiraCrossJoinNudges',
			},
			attributes: {
				cloudId,
				accountIds: JSON.stringify(collaborators.map((c) => c.id)),
				errorResponse: getErrorResponse(error),
			},
			error,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw new Error('Get Confluence users error');
	}
};

const getErrorResponse = (error: unknown) => {
	try {
		return JSON.stringify(error);
	} catch (e: unknown) {
		// Swallow error as the error is already in the analytic event.
		return undefined;
	}
};

const getInviteesUrl = '/gateway/api/growth/invite-on-link-insert/get-invitees';

export const getUsersWithProductAccess = async (
	cloudId: string,
	product: CrossJoinTargetProduct,
	collaborators: Collaborators,
): Promise<Collaborators> => {
	const accountIds = collaborators.map((u) => u.id);
	const lackingAccess = await fetchJson<AccountIds>(getInviteesUrl, {
		method: 'POST',
		body: JSON.stringify({ cloudId, product, accountIds }),
	});

	return collaborators.filter((c) => !lackingAccess.includes(c.id));
};
